import {connect} from "react-redux";
import RouteMapPoints from "./RouteMapPoints";
import {excludeCity} from "../../store/actions";

const mapStateToProps = state => ({
  showPassingCitiesInRouteDetails: state.showPassingCitiesInRouteDetails
});

const mapDispatchToProps = dispatch => ({
  /** @param {City} city */
  excludeCity: city => dispatch(excludeCity(city))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RouteMapPoints);
